@for (line of lines(); track $index; let odd = $odd; let last = $last) {
  <p
    class="break-words"
    [class.mb-2]="!last && odd"
    [class.font-bold]="odd"
  >
    {{ line }}
  </p>
}
